<template>
  <div>

  <div class=" mb-10">
    <v-row>
        <v-col cols="12" sm="6">
            <v-list>
            <v-list-item>
                <h6 class="ma-0 mr-2">
                    <v-chip

                        color="#607D8B"
                        class="ml-0 mr-2  "
                        label
                        small
                        >
                        <span class="white--text">Toca</span>
                    </v-chip>
                </h6>
                <span> {{ apelacion.toca.numero }}/{{ apelacion.toca.anio }} </span>
                <span v-if="apelacion.toca.complemento">
                  -{{ apelacion.toca.complemento }}
                </span>
            </v-list-item>

            <v-divider class="mt-n1"></v-divider>
            <v-list-item>
                <h6 class="ma-0 mr-2">
                    <v-chip

                        color="#607D8B"
                        class="ml-0 mr-2  "
                        label
                        small
                        >
                        <span class="white--text">Carpeta. Adva</span>
                    </v-chip>
                </h6>
                <span>{{ apelacion.toca.expediente }}</span>
            </v-list-item>
            <v-divider class="mt-n1"></v-divider>

            <v-list-item>
                <h6 class="ma-0 mr-2">
                    <v-chip

                        color="#607D8B"
                        class="ml-0 mr-2  "
                        label
                        small
                        >
                        <span class="white--text">Num. Oficio</span>
                    </v-chip>
                </h6>
                <span>{{ apelacion.oficio }}</span>
            </v-list-item>
            <v-divider class="mt-n1"></v-divider>
            <v-list-item>
                <h6 class="ma-0 mr-2">
                    <v-chip

                        color="#607D8B"
                        class="ml-0 mr-2  "
                        label
                        small
                        >
                        <span class="white--text">Juzgado</span>
                    </v-chip>
                </h6>
                <span>
                  {{ apelacion.juzgado.nombre }}<br>
                  DISTRITO {{ apelacion.juzgado.distrito_data.nombre }}
                </span>
            </v-list-item>
            <v-divider class="mt-n1"></v-divider>
            <v-list-item>
                <h6 class="ma-0 mr-2">
                    <v-chip

                        color="#607D8B"
                        class="ml-0 mr-2  "
                        label
                        small
                        >
                        <span class="white--text">Recusro</span>
                    </v-chip>
                </h6>
                <span>
                  {{ apelacion.tipo_apelacion.tipo_recurso }}
                </span>
            </v-list-item>
            <v-divider class="mt-n1"></v-divider>
            <v-list-item>
                <h6 class="ma-0 mr-2">
                    <v-chip

                        color="#607D8B"
                        class="ml-0 mr-2  "
                        label
                        small
                        >
                        <span class="white--text">Tipo Oficio</span>
                    </v-chip>
                </h6>
                <span>{{ apelacion.tipo_apelacion.nombre }}</span>

            </v-list-item>
            <v-divider class="mt-n1"></v-divider>
            </v-list>
        </v-col>
        <!-- <v-divider inset vertical></v-divider> -->
        <v-col cols="12" sm="6">
            <v-list>
              <v-list-item>
                  <h6 class="ma-0 mr-2">
                      <v-chip

                          color="#607D8B"
                          class="ml-0 mr-2  "
                          label
                          small
                          >
                          <span class="white--text">Apelante</span>
                      </v-chip>
                  </h6>
                  <span>{{ apelacion.apelante }}</span>
              </v-list-item>
              <v-divider class="mt-n1"></v-divider>
              <v-list-item>
                  <h6 class="ma-0 mr-2">
                      <v-chip

                          color="#607D8B"
                          class="ml-0 mr-2  "
                          label
                          small
                          >
                          <span class="white--text">Inculpado</span>
                      </v-chip>
                  </h6>
                  <span>{{ apelacion.inculpado }}</span>
              </v-list-item>
              <v-divider class="mt-n1"></v-divider>
              <v-list class="ml-4 mr-4">
                  <h6 class="ma-0 mr-2">
                      <v-chip

                          color="#607D8B"
                          class="ml-0 mr-2  "
                          label
                          small
                          >
                          <span class="white--text">Delito(s)</span>
                      </v-chip>
                  </h6>

                  <ul v-for="(delito, i) in apelacion.apelacion_delitos" :key="i">
                    <li>{{ delito.nombre }}</li>
                  </ul>
              </v-list>
              <v-divider class="mt-n1"></v-divider>
              <v-list-item>
                  <h6 class="ma-0 mr-2">
                      <v-chip

                          color="#607D8B"
                          class="ml-0 mr-2  "
                          label
                          small
                          >
                          <span class="white--text">Fecha Auto Apelante</span>
                      </v-chip>
                  </h6>
                  <span>{{ apelacion.fecha_apelacion | formatDate }}</span>
              </v-list-item>
              <v-divider class="mt-n1"></v-divider>
              <v-list-item>
                  <h6 class="ma-0 mr-2">
                      <v-chip

                          color="#607D8B"
                          class="ml-0 mr-2  "
                          label
                          small
                          >
                          <span class="white--text">Fecha Recepción</span>
                      </v-chip>
                  </h6>
                  <span>{{ apelacion.fecha_recepcion.slice(0,10) | formatDate }}</span>
              </v-list-item>
              <v-divider class="mt-n1"></v-divider>
              <v-list-item>
                  <h6 class="ma-0 mr-2">
                      <v-chip

                          color="#607D8B"
                          class="ml-0 mr-2  "
                          label
                          small
                          >
                          <span class="white--text">Fecha Turno</span>
                      </v-chip>
                  </h6>
                  <span v-if="apelacion.fecha_turno">
                    {{ apelacion.fecha_turno | formatDate }}
                  </span>
                  <span v-else>
                    <v-icon
                      class="mr-2"
                      color="grey"
                    >
                      mdi-minus
                    </v-icon>
                  </span>
              </v-list-item>
            </v-list>
        </v-col>
    </v-row>
  </div>


</div>

</template>

<script>
  import { mapGetters } from 'vuex'
  import ApelacionElectronica from "@/components/ApelacionElectronica";
  import SinMateria from "@/components/SinMateria";
  import CancelaToca from "@/components/CancelaToca";
  export default {
    components: {
      ApelacionElectronica, SinMateria, CancelaToca
    },
    props: {
      apelacion: {
        type: Object,
        required: true
      },
      cuenta: {
        type: Object,
        required: false
      },
      role: {
        type: String,
        required: true
      }
    },
    data: () => ({
      motivos:'',
      observaciones_sin_materia:'',
      dialogSinMateria: false,
      dialogCancelaToca: false,
      active_tab: {},
      valid: false,
      loading: false,
      menu_fecha_sentencia: false,
      menu_fecha_baja: false,
      fecha_sentencia: '',
      fecha_baja: '',
      archivar_toca: false,
      rules: {
        required:v => !!v.trim() || 'Campo requerido',
        requiredSelect:v => !!v|| 'Campo requerido'
      },
    }),
    computed: {
      ...mapGetters([ "currentUser", "getAllPonencias" ])
    },
    mounted(){
      this.$store.dispatch("GET_PONENCIAS", { url: "ponencias" });
      this.active_tab = this.$route.params
      if (this.cuenta && this.cuenta.colegiada) {
        this.resultado = this.apelacion.documentos.find( doc =>
          doc.categoria_id === 3 && doc.url_evidencia != null
        );
        if (this.resultado) {
          this.archivar_toca = true
        }
      }
    },
    methods:{
      sinMateria(){
        this.dialogSinMateria = true
      },
      closeSinMateria (val) {
        this.dialogSinMateria = false
        this.observaciones_sin_materia = ''
      },
      cancelaToca(){
        this.dialogCancelaToca = true
      },
      closeCancelaToca (val) {
        this.dialogCancelaToca = false
        this.motivos = ''
      }
    }
  };
</script>
